import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";
import { getAccessToken, refreshSession } from "./session";

export default function connectToSocket() {
  let disposed = false;
  let retryingAuth = false;
  let attemptedAuth = false;
  let stableTimer;
  const base = getBackendUrl() || "";
  const workspace = base.match(/^(https?:\/\/[^/]+)(\/workspaces\/[a-f0-9]{16})$/);
  const socket = openSocket(workspace ? workspace[1] : base, {
    path: workspace ? workspace[2] + "/socket.io" : "/socket.io",
    autoConnect: false,
    transports: ["websocket", "polling"],
    query: { token: getAccessToken() },
  });
  const updateToken = () => {
    if (disposed) return;
    const token = getAccessToken();
    socket.io.opts.query = { ...socket.io.opts.query, token };
    if (!token) socket.close();
    else if (!socket.connected) socket.connect();
  };
  const originalDisconnect = socket.disconnect.bind(socket);
  // Components already call disconnect() on unmount: also remove our listeners.
  socket.disconnect = () => {
    disposed = true;
    clearTimeout(stableTimer);
    window.removeEventListener("zapticket:token-updated", updateToken);
    return originalDisconnect();
  };
  window.addEventListener("zapticket:token-updated", updateToken);
  socket.io.on("reconnect_attempt", () => {
    socket.io.opts.query = { ...socket.io.opts.query, token: getAccessToken() };
  });
  socket.on("connect", () => {
    clearTimeout(stableTimer);
    stableTimer = setTimeout(() => { if (socket.connected) attemptedAuth = false; }, 10000);
  });
  socket.on("disconnect", async reason => {
    clearTimeout(stableTimer);
    if (reason !== "io server disconnect" || disposed || retryingAuth || attemptedAuth || !getAccessToken()) return;
    attemptedAuth = true;
    retryingAuth = true;
    try { await refreshSession(); }
    catch (error) { /* HTTP authentication handles expired login sessions. */ }
    finally { retryingAuth = false; }
  });
  updateToken();
  return socket;
}
